import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import {
  PatientCostCarrierId,
  type PatientCostCarrierIdType,
} from '@app/icare/entities/patient/schema/PatientCostCarrier'
import type { PatientCostCarrierExemption } from '@app/icare/entities/patient/schema/PatientCostCarrierExemption'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientCostCarrierOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_costCarrier/-components/PatientCostCarrierOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const exemptionsQuery = (patientCostCarrierId: PatientCostCarrierIdType) =>
  localResultQueryOptions({
    query: db
      .selectFrom('patientCostCarrierExemption')
      .selectAll()
      .where('patientCostCarrierId', '=', patientCostCarrierId)
      .where('deletedAt', 'is', null),
    tables: ['patientCostCarrierExemption'],
  })

export const Route = createFileRoute('/_app/patienten/$id/_edit/_costCarrier/kostentraeger/$relation')({
  params: entityParams({ id: PatientId, relation: PatientCostCarrierId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(exemptionsQuery(params.relation as PatientCostCarrierIdType)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientCostCarrierOverview patientId={id} relationId={relation} />
}
